export const TOPBAR_SELECTOR = '#topbar-navigation';

export const MIN_REFLOW_VIEWPORT_WIDTH = 1280;

export const WORKSPACE_REFLOW_QUERY = `(min-width: ${MIN_REFLOW_VIEWPORT_WIDTH}px)`;
